import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import './LightSwitch.scss';

const LightSwitch = ({ changeDarkMode }) => {
    const [switchStatus, setSwitchStatus] = useState("on");
    const [showSwitch, setShowSwitch] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setShowSwitch(true);
        }, 7800);
    }, []);

    return (
        <motion.div drag className={`light-switch ${showSwitch ? 'show' : ''}`}>
            <h3 className="light-switch-title">Light</h3>
            <div className="light-switch-container">
                <div className={"light-switch-mode-container " + switchStatus}>
                    <div className="light-switch-mode top"  onClick={() =>{
                        setSwitchStatus("off")
                        changeDarkMode(false);
                    }}>
                        <div className="switch-face hidden"></div>
                        <div className="switch-face front"><p>I</p></div>
                    </div>
                    <div className="light-switch-mode bottom"  onClick={() =>{
                        setSwitchStatus("on")
                        changeDarkMode(true);
                    }}>
                        <div className="switch-face front"><p>O</p></div>
                        <div className="switch-face hidden"></div>
                    </div>
                </div>
            </div>
            <h3 className="light-switch-title">Dark</h3>
        </motion.div>
    );
}

export default LightSwitch;

